import { Component, Input } from '@angular/core';

export type NavigationItemOptions = {
    text: string;
    routerLink: string;
};

@Component({
    selector: '[piNavigationItem]',
    host: {
        class: 'piNavMenu--Item'
    },
    template: `
        <a
            [routerLink]="isActive ? piNavigationItem.routerLink : null"
            routerLinkActive="active"
            class="piNavMenu--Link-newNavStyle"
            [ngClass]="{ inactiveLink: !isActive }"
            tooltip
            [tooltipContent]="inactiveTooltip"
            [tooltipDisabled]="isActive"
            tooltipPlacement="right"
        >
            {{ piNavigationItem.text }}
        </a>
        <tooltip-content #inactiveTooltip>
            <inactive-feature-tooltip-content></inactive-feature-tooltip-content>
        </tooltip-content>
    `,
    standalone: false
})
export class NavigationItemComponent {
    @Input()
    piNavigationItem: NavigationItemOptions;
    @Input()
    isActive = true;
}
